import { render, staticRenderFns } from "./ModalSelectPartiteSubPartite.vue?vue&type=template&id=2382870c"
import script from "./ModalSelectPartiteSubPartite.vue?vue&type=script&lang=js"
export * from "./ModalSelectPartiteSubPartite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports